import request from '@/utils/request'

// 取得短信模版-银行关键字列表
export function getSmsTemplateBankKeyword() {
  return request({
    url: '/sys/getSmsTemplateBankKeyword',
    method: 'get',
  })
}

// 取得银行卡设置限额时间区间(小时)
export function getUpdateAccountLimitFrequency() {
  return request({
    url: '/sys/getUpdateAccountLimitFrequency',
    method: 'get',
  })
}

// 根据ID删除策略关连用户
export function tacticsUserRelationDelete(id) {
  return request({
    url: `/sys/tacticsUserRelation/delete/${id}`,
    method: 'delete',
  })
}

// 修改策略关连用户
export function tacticsUserRelationUpdate(id, data) {
  return request({
    url: `/sys/tacticsUserRelation/update/${id}`,
    method: 'post',
    data: data,
  })
}

// 添加策略关连用户
export function tacticsUserRelationCreate(data) {
  return request({
    url: '/sys/tacticsUserRelation/create',
    method: 'post',
    data: data,
  })
}

// 根据ID删除派单策略
export function dispatchTacticsDelete(id) {
  return request({
    url: `/sys/dispatchTactics/delete/${id}`,
    method: 'delete',
  })
}

// 修改派单策略
export function dispatchTacticsUpdate(id, data) {
  return request({
    url: `/sys/dispatchTactics/update/${id}`,
    method: 'post',
    data: data,
  })
}

// 添加派单策略
export function dispatchTacticsCreate(data) {
  return request({
    url: '/sys/dispatchTactics/create',
    method: 'post',
    data: data,
  })
}

// 取得派单策略
export function dispatchTacticsListAll(params) {
  return request({
    url: '/sys/dispatchTactics/listAll',
    method: 'get',
    params: params,
  })
}

export function addSetting(data) {
  return request({
    url: '/sys/create',
    method: 'post',
    data: data,
  })
}

export function editSetting(data) {
  return request({
    url: `/sys/update/${data.id}`,
    method: 'put',
    data: data,
  })
}

export function deleteSetting(data) {
  return request({
    url: `/sys/delete/${data}`,
    method: 'delete',
  })
}

export function getSettingList(params) {
  return request({
    url: '/sys/listAll',
    method: 'get',
    params: params,
  })
}

// 取得地区讯息
export function getRegionsInfo() {
  return request({
    url: '/sys/getRegionsInfo',
    method: 'get',
  })
}

// 取得下线帐号原因列表
export function getLogOutReason() {
  return request({
    url: '/sys/getLogOutReason',
    method: 'get',
  })
}

// 系统级别禁用银行卡原因列表
export function getAdminDisableReason() {
  return request({
    url: '/sys/getAdminDisableReason',
    method: 'get',
  })
}

// 获取基础设定档
export function getBaseConfig() {
  return request({
    url: '/sys/baseConfig',
    method: 'get',
  })
}

// 取得出款失败或冲正原因列表(卡主)
export function getWithdrawFailReasonForCustomer() {
  return request({
    url: '/sys/getWithdrawFailReasonForCustomer',
    method: 'get',
  })
}

// 取得出款失败或冲正原因列表(玩家)
export function getWithdrawFailReasonForPlayer() {
  return request({
    url: '/sys/getWithdrawFailReasonForPlayer',
    method: 'get',
  })
}

// 纯手动客服确认到帐金额警示
export function getWarningAmountLimitToKFConfirm() {
  return request({
    url: '/sys/getWarningAmountLimitToKFConfirm',
    method: 'get',
  })
}

// 取得代理登入domain
export function getAgentLoginDomain() {
  return request({
    url: '/sys/getAgentLoginDomain',
    method: 'get',
  })
}

// 卡主额度变更预审核表功能相关设置
export function getAmsCheckApplySetting() {
  return request({
    url: '/sys/getAmsCheckApplySetting',
    method: 'get',
  })
}

// 更新卡主额度变更预审核表相关设置
export function updateAmsCheckApplySetting(params) {
  return request({
    url: '/sys/updateAmsCheckApplySetting',
    method: 'post',
    params,
  })
}


// WEBPACK FOOTER //
// ./src/api/setting.js